import {useState} from 'react';
import {Upload, Button, Spin, message} from 'antd';
import {
  UploadOutlined,
  ReloadOutlined,
  DeleteOutlined,
  LinkOutlined,
} from '@ant-design/icons';
import {UploadVideoToBucket} from 'pages/campaigns/new/screens/legalDocument/uploadDocument';
import styles from './uploadCsv.module.scss';

export const UploadCSV = ({
  value,
  onChange,
  bucket = 'campaign-bucket-images',
  clear,
  accept = '.csv',
  disabled = false,
  sampleLink,
}) => {
  const [isUploading, setIsUploading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [fileName, setFileName] = useState('');

  const beforeUpload = file => {
    const isCsv = file.type === 'text/csv' || /\.csv$/i.test(file.name);
    if (!isCsv) {
      message.error('Please upload a .csv file');
    }
    return isCsv || Upload.LIST_IGNORE;
  };

  const handleCustomRequest = async options => {
    const {file, onSuccess, onError} = options;
    setIsUploading(true);
    setFileName(file?.name || '');
    setProgress(0);
    try {
      const url = await UploadVideoToBucket(file, bucket, setProgress);
      if (!url) {
        throw new Error('Upload failed');
      }
      onChange?.(url);
      onSuccess?.({url}, file);
    } catch (err) {
      message.error('Upload failed');
      onError?.(err);
    } finally {
      setIsUploading(false);
      setProgress(0);
    }
  };

  const clearFile = () => {
    clear?.();
    setFileName('');
    setProgress(0);
  };

  return (
    <div className={styles.uploadCSV}>
      <label className={styles.label}>
        {sampleLink ? (
          <div className={styles.sample}>
            <a href={sampleLink} target="_blank" rel="noreferrer">
              Click to View Sample
            </a>
          </div>
        ) : null}
      </label>
      <div className={styles.box} data-has-value={Boolean(value)}>
        {isUploading ? (
          <div className={styles.uploading}>
            <Spin />
            <span>{progress}%</span>
          </div>
        ) : value ? (
          <div className={styles.fileInfo}>
            <div className={styles.meta}>
              <strong className={styles.name}>
                {fileName || 'uploaded.csv'}
              </strong>
              <a
                className={styles.link}
                href={value}
                target="_blank"
                rel="noreferrer"
                title="Open uploaded file">
                <LinkOutlined />
                <span>Open</span>
              </a>
            </div>
            <div className={styles.actions}>
              <Upload
                accept={accept}
                showUploadList={false}
                beforeUpload={beforeUpload}
                customRequest={handleCustomRequest}
                disabled={disabled}>
                <Button icon={<ReloadOutlined />} disabled={disabled}>
                  Replace
                </Button>
              </Upload>
              <Button
                danger
                icon={<DeleteOutlined />}
                onClick={clearFile}
                disabled={disabled}>
                Remove
              </Button>
            </div>
          </div>
        ) : (
          <Upload
            accept={accept}
            multiple={false}
            showUploadList={false}
            beforeUpload={beforeUpload}
            customRequest={handleCustomRequest}
            disabled={disabled}>
            <div className={styles.dropzone}>
              <UploadOutlined />
              <span>Click to upload or drag CSV here</span>
            </div>
          </Upload>
        )}
      </div>
    </div>
  );
};
